import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyState = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 154,
	height: 65,
	viewBox: "0 0 154 65",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M153.247 60.839C154.147 61.739 154.197 64.329 152.867 64.959L0.916958 64.759C-0.873042 62.299 0.416958 60.029 3.43696 60.199H150.647C151.417 60.269 152.697 60.289 153.247 60.839Z",
			fill: "#3364A7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.78 53.1101C26.12 52.4501 25.96 50.6001 26.4 49.7301C27.4 47.7401 39.12 47.8601 41.28 48.3401C44.66 49.1001 44.9 53.1301 41.87 53.7101C39.67 54.1301 31.9 53.9501 29.39 53.7401C28.62 53.6701 27.34 53.6501 26.79 53.1001L26.78 53.1101Z",
			fill: "#3364A7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M127.3 53.1101C126.44 53.9601 114.57 53.9901 112.74 53.7001C109.05 53.1201 109.19 48.8401 113.24 48.2701C115.35 47.9801 125.1 47.9801 126.58 48.8301C127.97 49.6401 128.4 52.0101 127.3 53.1001V53.1101Z",
			fill: "#3364A7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M112.34 14.4401C112.99 15.0801 113.09 16.4701 112.72 17.3001C112.55 17.6901 107.76 22.7701 106.99 23.5601C105.85 24.7301 102.87 28.2001 101.45 28.0401C99.3399 27.8101 98.5599 25.8001 99.3699 23.9301C99.7599 23.0101 108.27 14.1701 109.36 13.9301C110.24 13.7301 111.71 13.8001 112.35 14.4401H112.34Z",
			fill: "#3364A7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.2899 19.6301C42.8899 19.1501 41.4799 17.5501 41.3599 17.2901C40.2499 14.9401 42.5799 12.9201 45.0999 14.0701C45.7899 14.3901 54.2599 23.1501 54.6299 24.0001C55.2099 25.3501 55.2599 26.0001 54.3499 27.2901L51.1099 27.5201L43.2899 19.6301Z",
			fill: "#3364A7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M74.5499 1.60011C75.2199 -0.679893 79.5399 0.0401069 79.5399 2.10011V16.5701C79.5399 18.2001 74.5499 18.2001 74.5499 16.5701C74.5499 13.5301 73.9399 3.67011 74.5499 1.60011Z",
			fill: "#3364A7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M76.2995 20.2306C101.555 19.0813 112.348 42.7724 106.925 61.1896H100.918C106.627 45.9747 98.6015 25.2375 76.8054 25.672C55.6266 26.093 47.7131 46.2894 53.3483 61.1896H47.8151C42.3607 43.6625 51.5001 21.3589 76.2995 20.2306Z",
			fill: "#3365A7"
		})
	]
});
export default SvgEmptyState;
